import styled from "styled-components";
import { Headline, Paragraph } from "../../../components/styled/Text";

const ErrorBlockContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  max-width: 600px;
  margin: 0 auto;
  width: 100%;
`;

const ErrorBlockHeadline = styled(Headline)`
  font-size: 34px;
`;

const ErrorBlock = () => {
  return (
    <ErrorBlockContainer>
      <ErrorBlockHeadline textAlign="center">
        Oops! Something went wrong.
      </ErrorBlockHeadline>
      <Paragraph textAlign="center" marginTop="15px">
        While we were trying to process your snapshot, something went wrong.
        Doublecheck if you are connected to the right chain and try again.
      </Paragraph>
    </ErrorBlockContainer>
  );
};

export default ErrorBlock;
